export default class TableDefinitionModel {
  id;

  dataProvider;

  dataFunction;

  dataTransformer;

  constructor(
    id,
    dataProvider,
    dataFunction,
    dataTransformer = (data) => data,
  ) {
    this.id = id;
    this.dataProvider = dataProvider;
    this.dataFunction = (state) => state.listing[this.id].data;
    this.dataTransformer = dataTransformer;
  }

  getDataFunction = () => this.dataFunction;
}
